// Helper function to format the backend ISO date string
export const formatDateTime = (isoString) => {
  if (!isoString || isoString === "-") return "-";
  try {
    const date = new Date(isoString);
    // Check if the date is valid
    if (isNaN(date.getTime())) return isoString;

    // Formats to: "Jun 18, 2026, 12:24 PM"
    return date.toLocaleString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  } catch {
    return isoString; // Fallback to raw string if parsing fails
  }
};
